import app from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/analytics'

// Firebase configuration information
const config = {
  apiKey: "AIzaSyAvOui5WXHrnzXDrOu28XigebQdefkwL5Q",
  authDomain: "agent-travel-platform.firebaseapp.com",
  databaseURL: "https://agent-travel-platform.firebaseio.com",
  projectId: "agent-travel-platform",
  storageBucket: "agent-travel-platform.appspot.com",
  messagingSenderId: "962734397504",
  appId: "1:962734397504:web:68520b6ee606f6ba",
  measurementId: "G-ZHXGTHJPM3"
};

// Set variables for Firebase to be initialized and then different DBs to be referenced
const firebaseApp = app.initializeApp(config);
export const fireStorage = firebaseApp.storage();
export const analytics = app.analytics();
export const auth = firebaseApp.auth();

let hostname = location.hostname.replace(/\./gi, "").toLowerCase();

window.TravelPlatform = {key: hostname};
document.cookie = `x-sessionId=${Date.now()};path=/`;
document.cookie = `x-agencyId=${hostname};path=/`;

analytics.setUserProperties({agency: hostname});